var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, takeUntil, filter } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { ExploreState } from 'src/app/explore/state/explore.state';
import { Select } from '@ngxs/store';
var SearchFieldComponent = /** @class */ (function () {
    function SearchFieldComponent(router, ref) {
        this.router = router;
        this.ref = ref;
        this.ngUnsubscribe = new Subject();
        this.queryThrottle = 300;
        this.minLength = 2;
        this.searchRoute = '/explore/search/';
        this._expanded = false;
        this.searchField = new FormControl('');
    }
    Object.defineProperty(SearchFieldComponent.prototype, "expanded", {
        get: function () {
            return this._expanded;
        },
        set: function (value) {
            var _this = this;
            this._expanded = value;
            if (value) {
                setTimeout(function () {
                    _this.searchInputField.nativeElement.focus();
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchFieldComponent.prototype.ngOnInit = function () {
        var _this = this;
        // sync expanded state
        this.expanded = this.isSearchRoute();
        this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) {
            _this.expanded = _this.isSearchRoute();
            _this.ref.markForCheck();
        });
        // sync query
        this.query$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (query) {
            _this.searchField.setValue(query);
        });
        // delayed search
        this.searchField.valueChanges
            .pipe(debounceTime(this.queryThrottle), takeUntil(this.ngUnsubscribe))
            .subscribe(function (query) {
            if (query.length >= _this.minLength) {
                _this.routeSearch(query);
            }
        });
    };
    SearchFieldComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SearchFieldComponent.prototype.handleToggleClick = function () {
        this.expanded = !this.expanded;
    };
    SearchFieldComponent.prototype.handleCloseClick = function () {
        this.expanded = false;
    };
    SearchFieldComponent.prototype.routeSearch = function (query) {
        // search is managed by route
        this.router.navigate([this.searchRoute, query], {
            skipLocationChange: false,
            replaceUrl: this.isSearchRoute()
        });
    };
    SearchFieldComponent.prototype.isSearchRoute = function () {
        return !!this.router.url.match(this.searchRoute);
    };
    __decorate([
        Select(ExploreState.getSearchQuery),
        __metadata("design:type", Observable)
    ], SearchFieldComponent.prototype, "query$", void 0);
    return SearchFieldComponent;
}());
export { SearchFieldComponent };
